// extracted by mini-css-extract-plugin
module.exports = {"messageNoticeBarWrapper":"index_messageNoticeBarWrapper_u_rbq","messageNoticeBar":"index_messageNoticeBar_2K3Rl","warningIcon":"index_warningIcon_3jD6n"};